// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBoxes_root__2Vqre","noPad":"CheckBoxes_noPad__2ozMf","p":"CheckBoxes_p__22wZ7","warn":"CheckBoxes_warn__2DlPJ"};